// Defer all analytics tags so they don't block first paint / hurt LCP+TBT.
// Loads GA4 + GTM via requestIdleCallback after onClientEntry; tracks
// SPA pageviews on route changes for GA4 and FB Pixel.

const GA4_ID = 'G-ZP685XT8FC';
const GTM_ID = 'GTM-MDZ53CP';

function loadGTMandGA4() {
  if (typeof window === 'undefined' || window.__analyticsLoaded) return;
  window.__analyticsLoaded = true;

  // gtag bootstrap (shared between GA4 and GTM)
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA4_ID);

  // GA4 script
  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(gtagScript);

  // GTM script
  (function loadGTM(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? `&l=${l}` : '';
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', GTM_ID);
}

function scheduleIdle(fn) {
  if (typeof window === 'undefined') return;
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(fn, { timeout: 3500 });
  } else {
    setTimeout(fn, 2000);
  }
}

// Only the live site counts: Vercel previews, the staging deploy and localhost must not
// load GA4 or GTM, or their visits inflate the reports (seen in October 2026).
const LIVE_HOST = /(^|\.)tefl-iberia\.com$/;
function onLiveSite() {
  return typeof window !== 'undefined' && LIVE_HOST.test(window.location.hostname);
}

exports.onClientEntry = () => {
  if (!onLiveSite()) return;
  scheduleIdle(loadGTMandGA4);
};

// SPA route changes: fire a fresh pageview for GA4 + FB Pixel.
// These will no-op until the deferred scripts have loaded; once they have,
// every route change is tracked. (Gatsby fires onRouteUpdate after navigation.)
exports.onRouteUpdate = ({ location }) => {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
    });
  }
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'PageView');
  }
};
